import YFormPostQuickView from './PostQuickView';

export { YFormPostQuickView };
export default YFormPostQuickView;
